export const TIERS = [
  { id: 'TIER1', name: '1' },
  { id: 'TIER2', name: '2' },
];
